import { Prop, Watch } from "vue-property-decorator";
import Vue from "vue";

export class DayPickerVue extends Vue {
  /** Значение для пероида */
  @Prop() months!: Array<any>;

  /** Нижняя граница */
  @Prop() minDate!: string;

  /** Верхняя граница */
  @Prop() maxDate!: string;

  /** Цвет пикера */
  @Prop() color!: string;

  period: Array<any> = [];

  /** Отслеживание получение данных периода из вне и записываем их */
  @Watch("months", { immediate: true })
  periodChanged() {
    this.period = this.months;
  }

  /** Нажатие на кнопку ок вызываем события изменения периода и закрытия пикера */
  confirm() {
    if (this.period) {
      this.$emit("changeMonthValue", { period: this.period });
      this.$emit("hidePicker");
    }
  }

  /** Закрытие пикера */
  hidePicker() {
    this.$emit("hidePicker");
  }
}
